import { notUndefined } from '../utils/conditional-assert'

export declare type Tag = 'tag'
export declare type TagMetaGroup = 'tagMetaGroup'
export declare type Day = 'day'
export declare type Month = 'month'
export declare type Year = 'year'
export declare type Project = 'project'
export declare type TimesheetProject = 'timesheetProject'
export declare type TimesheetProjectName = 'timesheetProjectName'
export declare type TimesheetProjectClient = 'timesheetProjectClient'
export declare type Employee = 'employee'
export declare type HideEmployee = 'hideEmployee'
export declare type EmployeeFullName = 'employeeFullName'
export declare type Client = 'client'
export declare type State = 'state'

export declare type GroupBy =
    | Client
    | Employee
    | EmployeeFullName
    | HideEmployee
    | Project
    | TimesheetProject
    | TimesheetProjectClient
    | TimesheetProjectName
    | Year
    | Month
    | Day
    | Tag
    | TagMetaGroup
    | State

export interface Filter<T> {
    searchParams: T
    groupBy: Array<GroupBy>
    employeeId?: number
}

export interface HierarchyMenuItem {
    title: string
    level?: number
    children: Array<HierarchyMenuItem>
    path?: string
    isOpen: boolean
    accessFor: Array<string>
}

export const createHierarchyMenuItemFromChild = (hierarchyMenuItem: HierarchyMenuItem): HierarchyMenuItem => {
    const result: HierarchyMenuItem = {
        title: hierarchyMenuItem.title,
        level: hierarchyMenuItem.level ? hierarchyMenuItem.level : 1,
        path: hierarchyMenuItem.path,
        isOpen: false,
        accessFor: hierarchyMenuItem.accessFor,
        children: new Array<HierarchyMenuItem>()
    }
    if (hierarchyMenuItem.children && hierarchyMenuItem.children.length > 0) {
        hierarchyMenuItem.children.forEach((child: HierarchyMenuItem) => {
            child.level = notUndefined(result.level) + 1
            result.children.push(child)
        })
    }

    return result
}

export const createHierarchyMenuItem = (title: string, accessFor: Array<string>, path?: string): HierarchyMenuItem => ({
    title,
    isOpen: false,
    children: new Array<HierarchyMenuItem>(),
    path,
    accessFor
})
